import vuetify from '@/plugins/vuetify';

export default class Theme {
    [key: string]: string | number | boolean | Function;

    public token!: string;
    public primary!: string;
    public secondary!: string;
    public error!: string;
    public warning!: string;
    public scrollbar!: string;
    public 'label-text'!: string;
    public 'on-error'!: string;
    public 'on-warning'!: string;
    public 'on-secondary'!: string;

    public backgroundPath!: string;
    public logoPath!: string;
    public customStyles!: number;

    public status!: boolean;

    constructor(rawTheme: any) {
        // extract all theming properties
        const currentTheme = vuetify.framework.theme.themes.light;
        Object.keys(currentTheme).forEach(key => {
            this[key] = rawTheme[key] as string;
        });
        this.token = rawTheme.token;
        this.customStyles = Number(rawTheme.customStyles);
        this.backgroundPath = rawTheme.background_path;
    }
}
